import React from 'react'
import { RatablesSortByTypes } from './Ratables'

export type RatablesSortProps = { handleClick: (sortType: string) => void }

export const RatablesSort = ({ handleClick }: RatablesSortProps) => (
  <>
    <div className="heading--6">Sort by</div>
    <div className="search__issues">
      <form className="search__issues--form" name="issue__form">
        <div
          className="search__issues--type"
          onClick={() => handleClick(RatablesSortByTypes.MOST_RECENT)}
          onKeyUp={() => handleClick(RatablesSortByTypes.MOST_RECENT)}
          role="button"
          tabIndex={0}
        >
          <input type="radio" name="sort" value="Most Recent" />
          <span>Most Recent</span>
        </div>
        <div
          className="search__issues--type"
          onClick={() => handleClick(RatablesSortByTypes.DEBT_TYPE)}
          onKeyUp={() => handleClick(RatablesSortByTypes.DEBT_TYPE)}
          role="button"
          tabIndex={0}
        >
          <input type="radio" name="sort" value="Debt Type / Sub-Type" />
          <span>Debt Type / Sub-Type</span>
        </div>
      </form>
    </div>
  </>
)
export default RatablesSort
